import React from "react";
import Modal from "components/Modal";
import VideoPlayer from "components/VideoPlayer";
import styled from "styled-components";

export interface VideoModalProps {
  title?: string;
  src: string;
  onBlur: () => void;
}

const PaddingBox = styled.div`
  padding: 20px 0;
`

export default function VideoModal(props: VideoModalProps) {

  function renderTitle(): React.ReactElement | null {
    if (props.title) {
      return <div>{props.title}</div>
    }

    return null
  }

  return (
    <Modal
      renderHeader={renderTitle()}
      onBlur={props.onBlur}
    >
      <PaddingBox>
        <VideoPlayer src={props.src} />
      </PaddingBox>
    </Modal>
  ) || null
}
